import {type UseQueryResult, useQuery} from '@tanstack/react-query';

import type {CurrentUser} from '../types';
import {getRequest} from '../utils/httpClient';

/**
 * Who is signed in, plus the deployment's environment.
 *
 * Long staleTime: none of it changes within a session, and it gates the whole layout, so refetching it
 * would flash the environment banner.
 */
export const useCurrentUser = (): UseQueryResult<CurrentUser> =>
    useQuery({
        queryKey: ['currentUser'],
        queryFn: () => getRequest<CurrentUser>('/api/admin/me'),
        staleTime: 10 * 60 * 1000,
    });
